import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M903.529412,56 C1176.73412,56 1431.86824,177.411765 1603.42588,389.289412 L1603.42588,389.289412 L1427.91529,531.369412 C1299.38824,372.8 1108.17882,281.882353 903.529412,281.882353 C529.807059,281.882353 225.882353,585.807059 225.882353,959.529412 C225.882353,1333.25176 529.807059,1637.17647 903.529412,1637.17647 C1108.17882,1637.17647 1299.38824,1546.25882 1427.91529,1387.68941 L1427.91529,1387.68941 L1603.42588,1529.76941 C1431.86824,1741.64706 1176.73412,1863.05882 903.529412,1863.05882 C405.345882,1863.05882 0,1457.71294 0,959.529412 C0,461.345882 405.345882,56 903.529412,56 Z M993.091765,484.385882 L1152.79059,644.084706 L950.287059,846.588235 L1920,846.588235 L1920,1072.47059 L950.287059,1072.47059 L1152.79059,1274.97412 L993.091765,1434.67294 L517.948235,959.529412 L993.091765,484.385882 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconToggleStartSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconToggleStartSolid, _Component);

  var _super = _createSuper(IconToggleStartSolid);

  function IconToggleStartSolid() {
    _classCallCheck(this, IconToggleStartSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconToggleStartSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconToggleStart",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconToggleStartSolid.displayName = "IconToggleStartSolid";
  return IconToggleStartSolid;
}(Component);

IconToggleStartSolid.glyphName = 'toggle-start';
IconToggleStartSolid.variant = 'Solid';
IconToggleStartSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconToggleStartSolid;
export { IconToggleStartSolid };